import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {LocationCardScratchpadState} from '../../scratchpad/locationCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import locationFeedApi from 'common/src/modules/locationFeed/locationFeed.api';

const setLocationFeedToolSchema = z.object({
  feedId: z.number().describe('The location feed ID to set for the location card'),
});

export default function setLocationFeedTool() {
  async function execute(
    params: ToolExecuteParams<typeof setLocationFeedToolSchema, LocationCardScratchpadState>,
  ) {
    const {feedId} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<LocationCardScratchpadState>(
      agentScratchpad,
      NodeType.STORE,
    );

    if (!params.input.feedId) {
      return toolError('No feed ID provided');
    }

    const availableFeeds = await locationFeedApi.getFeedsNew();

    if (!availableFeeds.some((f) => f.id === feedId)) {
      return toolError(
        `Location feed with ID ${feedId} is not available. Available location feeds: ${availableFeeds.map((f) => `${f.id}: ${f.name}`).join(', ')}`,
      );
    }

    validatedScratchpad.card.locationFeedId = feedId;

    return toolResult(`Location feed set to: ${feedId}`);
  }

  return tool({
    name: V2CardAgentToolName.SetLocationFeed,
    displayName: 'Setting location feed',
    description: 'Set the location feed for the card.',
    execute,
    inputSchema: setLocationFeedToolSchema,
  });
}
